import React from "react";
import "../pages/css/add-property.css";

const PicUpload = ({ images, setImages, setData, data, dataErr, btnText }) => {
  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);

    const convertToBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      });

    const base64Images = await Promise.all(
      files.map(async (file) => ({
        name: file.name,
        base64: await convertToBase64(file),
      }))
    );

    setImages(base64Images);
    setData({
      ...data,
      pictures: base64Images.map((img) => img.base64),
    });
  };

  return (
    <div className="home-btn_s">
      <label htmlFor="picture" style={{ width: "100%" }}>
        <input
          type="file"
          id="picture"
          style={{ display: "none" }}
          multiple
          accept=".png,.svg,.jpg,.jpeg"
          onChange={handleFileChange}
        />

        <p>{btnText}</p>

        {/* {images?.length > 0 && (
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginTop: "10px",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {images.map((img, index) => (
              <img
                key={index}
                src={img.base64}
                alt="preview"
                width="100"
                height="100"
                style={{ objectFit: "cover", borderRadius: "5px" }}
              />
            ))}
          </div>
        )} */}
      </label>

      {dataErr?.pictures && <p>{dataErr.pictures}</p>}
    </div>
  );
};

export default PicUpload;
